'use client'

import { motion, useReducedMotion, type HTMLMotionProps } from 'motion/react'
import React from 'react'

type Props = Omit<HTMLMotionProps<'div'>, 'children'> & {
  children?: React.ReactNode
  delay?: number
  /** Deslocamento inicial em px (padrão 24). */
  y?: number
  ativo?: boolean
}

/** Fade + subida ao entrar na viewport (uma vez). Respeita `prefers-reduced-motion`. */
export function Revelar({ delay = 0, y = 24, ativo = true, children, ...rest }: Props) {
  const reduce = useReducedMotion()
  if (reduce || !ativo) {
    return (
      <div className={rest.className as string | undefined} style={rest.style as React.CSSProperties | undefined}>
        {children}
      </div>
    )
  }
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -8% 0px' }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </motion.div>
  )
}
